import axios from "axios";
import { axiosNoAuth } from "../../config/axiosInstances";
import { SET_PERSONALIZE_AUTH_DATA } from "./types";

export function getUserUUid(email, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.get(
        "https://xgfy-czuw-092q.m2.xano.io/api:ZZCtun0K/fetch_old_uid_and_details",
        {
          params: {
            email,
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (error) {
      console.log(error);
      errorCallback && errorCallback(error);
    }
  };
}
export function getPersonalizeUserData(
  email_id,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.post(
        "https://ninjacurate.learntube.ai/user_authenticate",
        {
          user_email: email_id,
        }
      );

      dispatch({
        type: SET_PERSONALIZE_AUTH_DATA,
        payload: response?.data,
      });

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}
export function getAllPersonalizeCourses(
  uid,
  token,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axios.post(
        "https://ninjacurate.learntube.ai/fetch_user_course_details/app_homepage",
        {
          uid,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function getUserPurchaseDetails(
  email,
  token,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axios.get(
        "https://xgfy-czuw-092q.m2.xano.io/api:ZZCtun0K/user_account_status",
        {
          params: {
            email,
          },

          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function searchCoursePersonalise(
  search,
  token,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axios.post(
        "https://ninjacurate.learntube.ai/fast_search",
        {
          skill: search,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (error) {
      console.log(error);
      errorCallback && errorCallback(error);
    }
  };
}

export function fetchUnpaidCourseUUID(
  user_uuid,
  subject,
  is_curation,
  token,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axios.post(
        "https://xgfy-czuw-092q.m2.xano.io/api:ZZCtun0K/fetch_uuid_unpaid",
        {
          user_uuid,
          subject,
          is_curation,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (error) {
      console.log(error);
      errorCallback && errorCallback(error);
    }
  };
}

export function generatePersonalisedOrderID(
  uuid,
  amount,
  product_name,
  token,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axios.post(
        "https://xgfy-czuw-092q.m2.xano.io/api:IfQi_Nyx/razorpay_ninjacurate_payment/create_order",
        {
          uid: uuid,
          amount,
          product_name,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (error) {
      console.log(error);
      errorCallback && errorCallback(error);
    }
  };
}

export function fetchPersonalisedRazorpayStatus(
  uid,
  payment_id,
  order_id,
  isError,
  razorpay_signature,
  errorObj,
  token,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axios.post(
        "https://xgfy-czuw-092q.m2.xano.io/api:ZZCtun0K/payment_status",
        {
          uid,
          payment_id,
          order_id,
          isError,
          razorpay_signature,
          errorObj,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (error) {
      console.log(error);
      errorCallback && errorCallback(error);
    }
  };
}

export function fetchPersonalisedCurationStatus(
  user_name,
  user_uuid,
  user_email,
  course_name,
  skill_difficulty,
  is_curation,
  new_uuid,
  token,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axios.post(
        "https://xgfy-czuw-092q.m2.xano.io/api:ZZCtun0K/course_after_paid",
        {
          user_name,
          user_uuid,
          course_name,
          skill_difficulty,
          user_email,
          is_curation,
          new_uuid,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (error) {
      console.log(error);
      errorCallback && errorCallback(error);
    }
  };
}

export function fetchPersonalisedLessonDetails(
  token,
  uid,
  subject_name,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axios.post(
        "https://ninjacurate.learntube.ai/fetch_user_course_data",
        {
          uid,
          subject_name,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (error) {
      console.log(error);
      errorCallback && errorCallback(error);
    }
  };
}

export function getPersonaliseUnlockedCourses(
  email,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axios.post(
        "https://xgfy-czuw-092q.m2.xano.io/api:ZZCtun0K/user_unlocked_courses",
        {
          email,
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function getCourseMetaTags(
  subject_name,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.get(
        "https://ninjacurate.learntube.ai/meta_tagger/fetch",
        {
          params: {
            subject_name,
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err);
    }
  };
}

export function getCourseContent(subject_name, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.get(
        "https://ninjacurate.learntube.ai/meta_tagger/fetch_course_data",
        {
          params: {
            subject_name,
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (e) {
      console.log(e);
      errorCallback && errorCallback(e);
    }
  };
}


export function getCustomCourse(name , email , phone , subject, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosNoAuth.post(
        "https://ninjacurate.learntube.ai/fetch_custom_course",
       {
        name,
        email,
        phone,
        subject,
        course_extra : true
       }
      );

      successCallback && successCallback(response.data);
    } catch (e) {
      console.log(e);
      errorCallback && errorCallback(e);
    }
  };
}

export function getUserCourseNames(uid, token , successCallback , errorCallback){
  return async function(dispatch){
    try{
      const response = await axiosNoAuth.post(
        "https://ninjacurate.learntube.ai/fetch_user_course_names",
       {
        uid
       },
       {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
      );

      successCallback && successCallback(response.data);
    }
    catch(e){
      console.log(e)
      errorCallback&& errorCallback(e);
    }
  }
}

export function getCurationStatus(user_id, subject_name , successCallback , errorCallback){
  return async function(dispatch){
    try{

     
        
        const response = await axiosNoAuth.post(
          "https://ninjacurate.learntube.ai/curate_status",
         {
          user_id,
          subject_name
         },
        )
  
        successCallback && successCallback(response.data);

      
    
    }
    catch(e){
      console.log(e)
      errorCallback&& errorCallback(e);
    }
  }
}

export function getPersonaliseSubscription(email , successCallback , errorCallback){
  return async function(dispatch){
    try{
        const response = await axiosNoAuth.get('https://xgfy-czuw-092q.m2.xano.io/api:ZZCtun0K/user_account_status',{
          params:{
            email
          }
        });

        successCallback && successCallback(response.data);
    }
    catch(e){
      console.log(e)
      errorCallback&& errorCallback(e);
    }
  }
}